<template>
  <div v-if="leftNavData">
    <b-button @click="addNew">
      Add
    </b-button>
    <draggable
      :list="leftNavData"
      class="content__wrapper"
      @end="reorder"
    >
      <div
        v-for="item in leftNavData"
        :key="item.id"
      >
        <item :left-nav-item="item" />
      </div>
    </draggable>
  </div>
</template>
<script>

import Item from './Item.vue';
import {createNamespacedHelpers} from 'vuex';
import {v4 as uuidv4} from 'uuid';
import { SELECTED_NAV_ITEM } from '@/store/modules/left-nav-customization/mutation-types';
import Draggable from 'vuedraggable';

const {
  mapMutations,
  mapState: LeftNavCustomizationMapState,
} = createNamespacedHelpers('leftNavCustomization');

export default {
  name: 'ItemList',
  components: {
    Item,
    Draggable,
  },
  computed: {
    ...LeftNavCustomizationMapState({
      leftNavData: state => state.leftNavData,
    }),
  },
  methods: {
    ...mapMutations({
      selectedNavItem: SELECTED_NAV_ITEM,
    }),
    addNew() {
      const element = {
        id: uuidv4(),
        name: 'New Item',
        icon: '',
        editable: true,
        visible: false,
        sortOrder: this.leftNavData.reduce((max, item) => Math.max(max, item.sortOrder), 0) + 1,
      };
      this.leftNavData.push(element);
      this.selectedNavItem(element);
    },
    async reorder(e){
      if (this.leftNavData && Array.isArray(this.leftNavData)) {
        this.leftNavData.forEach((item, index) => {
          item.sortOrder = index + 1;
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.content__wrapper {
  padding: 10px 0;
  height: 80%;
  max-height: 80%;
}
</style>